import Vue from 'vue';

Vue.component('controls-map-zoom', () => import('./controls/map-zoom'));
Vue.component('controls-year-selector', () => import('./controls/year'));

// Vue.component('google-maps-download', () => import('./google-maps/download'));
Vue.component('google-maps-info-window', () => import('./google-maps/info-window'));
Vue.component('google-maps-data-layer', () => import('./google-maps/data-layer'));
Vue.component('google-maps-loader', () => import('./google-maps/loader'));
Vue.component('google-maps-markers', () => import('./google-maps/markers'));
Vue.component('google-maps-marker-clusterer', () => import('./google-maps/marker-clusterer'));

Vue.component('list-header', () => import('./list/header'));
Vue.component('list-item', () => import('./list/item'));

Vue.component('filterable', () => import('./filter/advanced-filter'));

Vue.component('facets-item', () => import('./facets/item'));

Vue.component('hidden-elements-container', () => import('./hidden-elements/container'));

Vue.component('interval-markers', () => import('./interval/markers'));

Vue.component('popup', () => import('./modals/popup'));

Vue.component('summary-counter', () => import('./summary/counter'));
Vue.component('summary-graph', () => import('./summary/graph'));
Vue.component('summary-region', () => import('./summary/region'));
Vue.component('summary-info-box', () => import('./summary/info-box'));

Vue.component('search-bar', () => import('./search/search-bar'));
